import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { Drawer, Button, Icon } from "./ds";
import tokens from "./designTokens";
import EpisodesPanel from "./quality/EpisodesPanel";
import DreamsPanel from "./quality/DreamsPanel";

const useStyles = makeStyles({
  sectionHead: { fontFamily: tokens.fontBody, fontWeight: 600, fontSize: 12.5, color: tokens.textPrimary },
  footNote: { marginRight: "auto", fontFamily: tokens.fontBody, fontSize: 11, color: tokens.textHint },
});

export default function AgentDrawer({ bot, range, onClose }) {
  const classes = useStyles();

  if (!bot) return null;

  return (
    <Drawer
      open={!!bot}
      onClose={onClose}
      width={560}
      title={
        <span>
          {bot.project_id}
          <span style={{ color: tokens.textSecondary, fontWeight: 400 }}> · {bot.flow_id && bot.flow_id !== "main" ? bot.flow_id : "main"}</span>
        </span>
      }
      footer={
        <>
          <Typography component="span" className={classes.footNote}>Read-only — client data isn't editable here</Typography>
          <Button size="sm" variant="outlined" onClick={() => window.open(`/crm/${bot.project_id}`, "_blank")} icon={<Icon name="external-link" size={14} />}>
            Open project
          </Button>
        </>
      }
    >
      <Typography component="div" className={classes.sectionHead} style={{ marginBottom: 8 }}>Episodes</Typography>
      <EpisodesPanel projectId={bot.project_id} range={range} />

      <Typography component="div" className={classes.sectionHead} style={{ margin: "16px 0 8px" }}>Dreams</Typography>
      <DreamsPanel projectId={bot.project_id} />
    </Drawer>
  );
}
